import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyNomineService {
    static getTipi = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/nomine/tipi`;
            ApiService.postRequest(resolve, reject, url, {});
        });
    };

    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/nomine/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/nomine/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteNomina = (id_nomina) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/nomine/delete`;
            ApiService.postRequest(resolve, reject, url, { id_nomina });
        });
    };

    static download = (id_nomina, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/nomine/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_nomina, filename });
        });
    };
}
